import { NextApiResponse } from "next";
import { i18n } from "../../../../next-i18next.config";

export enum FeatureFlags {
  VehiclePurchase = "VehiclePurchase",
  C2CFinancing = "C2CFinancing",
  AftermarketQuoteMethod = "AftermarketQuoteMethod",
  InovatecFinancing = "InovatecFinancing",
  IcoAppraisalPhoneVerification = "IcoAppraisalPhoneVerification",
}

export async function revalidateStaticPagesForFlag(
  flag: FeatureFlags,
  res: NextApiResponse
) {
  let pages: string[] = [];

  switch (flag) {
    case FeatureFlags.VehiclePurchase:
      pages = [
        "/purchase/checklist",
        "/purchase/delivery",
        "/purchase/financing",
        "/purchase",
        "/purchase/personal-information",
        "/purchase/review",
        "/purchase/trade-in",
        "/purchase/warranty",
        // TODO unused now, but multiple page revalidation for VDP: pages/car/[...slug]
      ];

      break;
    case FeatureFlags.C2CFinancing:
      pages = [
        "/profile/loan-applications",
        "/purchase/consumer/checklist",
        "/purchase/consumer/coverages-intro",
        "/purchase/consumer/coverages",
        "/purchase/consumer/financing",
        "/purchase/consumer",
        "/purchase/consumer/introduction",
        "/purchase/consumer/personal-info",
        "/purchase/consumer/review",
        "/purchase/consumer/vehicle-details",
        "/purchase/consumer/vopay",
        "/purchase/consumer/seller/checklist",
        "/purchase/consumer/seller",
      ];

      break;
    case FeatureFlags.InovatecFinancing:
      pages = ["/purchase/consumer/introduction"];
      break;

    case FeatureFlags.AftermarketQuoteMethod:
    case FeatureFlags.IcoAppraisalPhoneVerification:
      // Nothing to revalidate
      break;
    default: {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const exhaustiveCheck: never = flag;
      throw new Error(`Unhandled flag: ${flag}`);
    }
  }

  if (pages.length === 0) return;

  const locales = [
    "",
    ...i18n.locales.filter((l) => l !== "zu").map((l) => `/${l}`),
  ];

  const localePages: string[] = [];

  for (let i = 0; i < pages.length; i += 1) {
    localePages.push(...locales.map((l) => l + pages[i]));
  }

  const sendBatch = async (batchPages: string[]) => {
    await Promise.all(batchPages.map((p) => res.revalidate(p.toLowerCase())));
  };

  // MaxListenersExceededWarning: Possible EventEmitter memory leak detected
  // `revalidate` pages by batch to fix warning until nextjs provides a way to
  // rebuild multiple pages.
  const batchSize = 10;

  const processBatch = async (index: number) => {
    if (index >= localePages.length) return;

    const batchPages = localePages.slice(index, index + batchSize);

    await sendBatch(batchPages);
    await processBatch(index + batchSize);
  };

  await processBatch(0);
}

export default {};
